import { createContext } from "react";

import { useAuthentication } from "./useAuthentication";

export const AuthenticationContext = createContext<
  ReturnType<typeof useAuthentication>
>({} as any);
